export interface AuthorizeResponse {
  redirectUrl: string;
}

export interface UserAccessTokenResponse {
  accessToken: string;
  /** UTC time at which `accessToken` stops being valid. Nullable in the contract, always filled by the backend. */
  accessTokenExpirationUtc?: string | null;
}

export type ApartmentAccessTokenResponse = UserAccessTokenResponse;

/** Refresh margin: the SDK refresher asks for a new token this long before the expiry. */
export const ACCESS_TOKEN_REFRESH_MARGIN_SECONDS = 0;

/**
 * Seconds until the token should be refreshed (expiry minus the margin, never below 0),
 * or `undefined` when the backend did not provide the expiry.
 */
export function accessTokenExpiresInSeconds(response: UserAccessTokenResponse): number | undefined {
  if (!response.accessTokenExpirationUtc) return undefined;
  const expiresAt = Date.parse(response.accessTokenExpirationUtc);
  if (Number.isNaN(expiresAt)) return undefined;
  return Math.max(0, Math.floor((expiresAt - Date.now()) / 1000) - ACCESS_TOKEN_REFRESH_MARGIN_SECONDS);
}

export interface BlockedScanText {
  title: string;
  subTitle: string;
}
